import React, {useState} from 'react';
import Link from 'next/link';

function SocialPanel() {

  return (
    <div className="App">

      <h2 className="display-3 title mb-3">Social Rewards</h2>
      <div>
        <p>
            Earn raffle tickets for <strong>exclusive raffles</strong> just by engaging with <a href="https://www.twitter.com/TheNoundles">@TheNoundles</a> on Twitter
        </p>
            <a
              href="/dashboard/social"
              className="btn btn-primary rounded-pill px-4 my-1"
              target="_blank"
              rel="noreferrer"
            >
              Learn More
            </a>{' '}
            <a
              href="https://noundlesrewardsprogram.com/"
              className="btn btn-primary rounded-pill px-4 my-1"
              target="_blank"
              rel="noreferrer"
            >
              Redeem Tickets
            </a>{' '}
      </div>
    </div>
  );
} 

export default SocialPanel;
